import { Expose } from "class-transformer";

export class SetValuationResponsibleDto {
  @Expose()
  valuationId: string;

  @Expose()
  responsibleUserId: string;
}
